import React from 'react';

// Small helper: reveal-on-scroll wrapper mirroring the original .gx-reveal behaviour.
export default function Reveal({ children, className = '', as: Tag = 'div', delay = 0, ...rest }) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => el.classList.add('gx-revealed'), delay);
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.08 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [delay]);
  return (
    <Tag ref={ref} className={`gx-reveal ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
